// docs/reference/user-design/constants/site.js의 명칭·순서·경로를 보존한다. 과거 인증·서버 메뉴 API는 가져오지 않는다.
export const NAV_MENUS = [
  {
    title: '교육원소개',
    to: '/intro',
    children: [
      { title: '테크에듀', to: '/intro' },
      { title: '경영원칙과비전', to: '/intro/vision' },
      { title: '사업영역', to: '/intro/business' },
      { title: '교육체계', to: '/intro/system' },
      { title: '교육운영', to: '/intro/operation' },
      { title: '교육플랫폼', to: '/intro/platform' },
      { title: '조직도', to: '/intro/organization' },
      { title: '찾아오시는길', to: '/intro/location' },
    ],
  },
  {
    title: '교육안내',
    to: '/guide',
    children: [
      { title: '사업주환급(기업)', to: '/guide/refund-company' },
      { title: '내일배움카드(개인)', to: '/guide/card-individual' },
      { title: '법정의무교육', to: '/guide/legal' },
      { title: '디지털융합', to: '/guide/digital' },
      { title: '산업안전보건교육', to: '/guide/safety' },
      { title: '기업직업훈련카드', to: '/guide/company-card' },
      { title: '과정개발', to: '/guide/course-development' },
      { title: '학습운영관리', to: '/guide/operation' },
      { title: '환불규정및절차', to: '/guide/refund-policy' },
      { title: '훈련생 유의사항', to: '/guide/notice' },
      { title: '모사답안처리기준', to: '/guide/plagiarism' },
      { title: '부정훈련방지안내', to: '/guide/fraud-prevention' },
      { title: '교육이용안내', to: '/guide/usage' },
    ],
  },
  {
    title: '법정필수교육',
    to: '/course/legal',
    children: [
      { title: '공통법정의무교육', to: '/course/legal/common' },
      { title: '직무법정의무교육', to: '/course/legal/job' },
    ],
  },
  {
    title: '산업안전교육',
    to: '/course/safety',
    children: [
      { title: '근로자', to: '/course/safety/worker' },
      { title: '관리감독자', to: '/course/safety/supervisor' },
    ],
  },
  {
    title: '직무향상교육',
    to: '/course/job',
    children: [
      { title: '매뉴픽처링', to: '/course/job/manufacturing' },
      { title: 'IT', to: '/course/job/it' },
      { title: '직무역량', to: '/course/job/competency' },
      { title: '자격증', to: '/course/job/certificate' },
      { title: '외국어', to: '/course/job/language' },
    ],
  },
  {
    title: '오프라인교육',
    to: '/course/offline',
    children: [
      { title: 'ChatGPT', to: '/course/offline/chatgpt' },
      { title: '디지털전환', to: '/course/offline/dx' },
      { title: '빅데이터', to: '/course/offline/bigdata' },
      { title: '디지털트윈', to: '/course/offline/digital-twin' },
      { title: 'ESG', to: '/course/offline/esg' },
      { title: 'JMP', to: '/course/offline/jmp' },
      { title: '제조AI', to: '/course/offline/manufacturing-ai' },
      { title: '지능형로봇', to: '/course/offline/robot' },
      { title: '안전보건관리', to: '/course/offline/safety' },
      { title: '금형기술', to: '/course/offline/mold' },
    ],
  },
  {
    title: '학습지원센터',
    to: '/support',
    children: [
      { title: '공지사항', to: '/support/notice' },
      { title: 'Q&A', to: '/support/qna' },
      { title: 'FAQ', to: '/support/faq' },
      { title: '뉴스레터', to: '/support/newsletter' },
      { title: '학습자료실', to: '/support/library' },
      { title: '용어사전', to: '/support/glossary' },
      { title: '뷰어다운로드', to: '/support/viewer' },
      { title: '1:1문의', to: '/support/inquiry' },
      { title: 'PC원격지원', to: '/support/remote' },
      { title: '수강후기', to: '/support/review' },
    ],
  },
  {
    title: '나의강의실',
    to: '/my',
    requiresAuth: true,
    children: [
      { title: '진행중인 과정', to: '/my' },
      { title: '재응시 과정', to: '/my/retake' },
      { title: '학습종료 과정', to: '/my/ended' },
      { title: '수강신청 내역', to: '/my/enrollment' },
      { title: '상담신청 내역', to: '/my/consult' },
      { title: '토론게시판', to: '/my/discussion' },
      { title: '나만의 학습노트', to: '/my/note' },
      { title: '개인/추가 결제', to: '/my/payment' },
      { title: '개인정보변경', to: '/my/profile' },
      { title: '인증방법', to: '/my/certify' },
      { title: '아이핀 인증방법', to: '/my/certify/ipin' },
      { title: '아이핀 발급방법', to: '/my/certify/ipin-issue' },
    ],
  },
]

export const QUICK_MENUS = [
  { key: 'consult', title: '1:1 학습상담', short: '상담', icon: 'chat', to: '/support/inquiry' },
  { key: 'remote', title: '원격지원', short: '원격', icon: 'monitor', to: '/support/remote' },
  { key: 'library', title: '자료실', short: '자료', icon: 'folder', to: '/support/library' },
  { key: 'b2b', title: '기업교육 신청양식', short: '신청양식', icon: 'download', href: '/files/company_edu.zip' },
]

export const FOOTER_LINKS = [
  { title: '이용약관', to: '/policy/terms' },
  { title: '개인정보처리방침', to: '/policy/privacy' },
  { title: '환불규정', to: '/policy/refund' },
  { title: '학습지원센터', to: '/support' },
]

// 업무가 구현되지 않은 경로도 명시적으로 등록한다. 목록 외 URL은 준비 화면 대신 404다.
// 나의강의실의 본인인증 안내(레거시 /certify/*)는 로그인 전에도 볼 수 있는 안내 페이지다.
const PUBLIC_GUIDES = new Set(['/my/certify', '/my/certify/ipin', '/my/certify/ipin-issue'])
const entries = new Map()
for (const menu of NAV_MENUS) {
  for (const entry of [menu, ...menu.children]) {
    entries.set(entry.to, { path: entry.to, title: entry.title, group: menu.title, parent: menu.to,
      protected: (menu.requiresAuth === true && !PUBLIC_GUIDES.has(entry.to)) || ['/support/qna', '/support/inquiry'].includes(entry.to),
      unavailable: entry.to === '/my/payment' })
  }
}
for (const entry of [...FOOTER_LINKS, { title: '회원가입 안내', to: '/signup' }]) {
  if (!entries.has(entry.to)) entries.set(entry.to, { path: entry.to, title: entry.title, group: '이용 안내', parent: '/', protected: false, unavailable: false })
}
export const PORTAL_PAGES = [...entries.values()]
export const PROTECTED_PORTAL_PATHS = PORTAL_PAGES.filter(page => page.protected).map(page => page.path)
